import { createFileRoute } from '@tanstack/react-router';

/**
 * Declare allowed search params for `/auth`.
 *
 * Without this, TanStack Start can get stuck in an SSR redirect loop while it
 * tries to "normalize" the URL when query params are present (e.g. `redirect=/app`).
 */
export const Route = createFileRoute('/auth')({
  ssr: false,
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
    plan:
      search.plan === 'monthly' || search.plan === 'annual'
        ? search.plan
        : undefined,
    checkout_success:
      typeof search.checkout_success === 'string'
        ? search.checkout_success
        : undefined,
    checkout_canceled:
      typeof search.checkout_canceled === 'string'
        ? search.checkout_canceled
        : undefined,
    checkout_session_id:
      typeof search.checkout_session_id === 'string'
        ? search.checkout_session_id
        : undefined,
    // Receipt-forwarding verification link (`/auth/receipt-forwarding/verify?token=...`).
    token: typeof search.token === 'string' ? search.token : undefined,
    // Forwarded from a failed Supabase Auth OAuth/OTP redirect (see _layout-app.tsx).
    error_code:
      typeof search.error_code === 'string' ? search.error_code : undefined,
    error_description:
      typeof search.error_description === 'string'
        ? search.error_description
        : undefined,
  }),
});

